<script lang="ts">import { cfgBrandTitle, cfgToThemeContentPath } from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
import { locale } from "@infinitro/global";
import { InfoCard } from "@infinitro/info-card";
import MarkdownIt from "markdown-it";
import VipSectionTitle from "./vip-section-title.svelte";
const BRAND_NAME = cfgBrandTitle();
const md = new MarkdownIt({
	html: true,
	breaks: true,
	linkify: true
});
let htmlContent = "";
async function fetchTerms(loc) {
	try {
		const url = cfgToThemeContentPath(`/vip/terms.${loc}.md`);
		const response = await fetch(url);
		if (!response.ok) {
			if (loc !== "en") {
				console.warn("Falling back to English VIP terms content...");
				await fetchTerms("en");
				return;
			}
			throw new Error(`Error fetching VIP terms content: ${response.statusText}`);
		}
		const text = (await response.text()).replaceAll("[BRAND]", BRAND_NAME);
		htmlContent = md.render(text);
	} catch (error) {
		console.warn("Failed to fetch VIP terms markdown:", error);
		htmlContent = "";
	}
}
$: if ($locale) {
	fetchTerms($locale);
}
</script>

<section class="vip-terms">
	<VipSectionTitle title={$t(Verbiage['vip_momentum_terms_title'])} />
	<InfoCard width="100%" borderRadius="20px">
		<div class="vip-terms-content">
			{@html htmlContent}
		</div>
	</InfoCard>
</section>

<style>
	.vip-terms {
    display: flex;
    width: 100%;
    flex-direction: column;
    gap: 1rem
}
	.vip-terms-content {
    font-size: 0.875rem;
    line-height: 1.25rem;
    --tw-text-opacity: 1;
    color: rgb(156 163 175 / var(--tw-text-opacity, 1))
}
	.vip-terms-content :global(ul) {
    display: flex;
    list-style-type: disc;
    flex-direction: column;
    gap: 0.5rem;
    padding-left: 1rem
}
	.vip-terms-content :global(ul ul) {
    margin-top: 0.5rem
}
</style>
